import * as _ from 'underscore';

import { getIntervalPlaceholderValue, DiscreteIntervalsKind } from '../tsx/DiscreteIntervals';
import * as DateTimeFunctions from './DateTimeFunctions';
import { themeVars } from '../../../pdc-platform/src/ts/themes/themeConstants';
import { IMappingValue } from '../../../_common/platform/tsx/IntervalsSelect';

const timeInfinityMinus = '00:00:00';
const timeInfinity = '24:00:00';

export class MappingUtilities {
    //LL: 02.11.20:
    static isImageMapping(themeObj, mapping: IMappingValue): boolean {
        let isImageMapp = false;
        //  colorMapp = theme["entities-model-color-mapping"];  = themeVars.entityAttributeMapping
        //  colorScalesFromTheme = theme[themeVars.color_scales_set];
        //  discreteMappingsFromTheme = theme[themeVars.discreteMapping_set];
        if (mapping != null) {
            if (mapping.mappingType === 'DiscreteMapping') {
                let discreteMappings = themeObj[themeVars.discreteMapping_set];
                let discreteMappingsObj = _.find(discreteMappings, function (dm: any) {
                    return dm.name === mapping.mappingName;
                });
                isImageMapp =
                    discreteMappingsObj != null && discreteMappingsObj.resultingType === DiscreteIntervalsKind.icon;
            }
            //else if (mapping.mappingType === 'ColorScale') {
            //    let colorScales = theme[themeVars.color_scales_set];
            //    colorScalesObj = _.find(colorScales, function(cs:any){ return cs.name === mapping.mappingName; })
            //}
        }

        return isImageMapp;
    }

    static evaluateDiscreteMappingDataType(mapObject): string {
        let _dataType = 'string';

        switch (mapObject.resultingType) {
            case DiscreteIntervalsKind.icon:
            case DiscreteIntervalsKind.label:
            case DiscreteIntervalsKind.color:
                _dataType = 'string';
                break;
            case DiscreteIntervalsKind.integer:
            case DiscreteIntervalsKind.real:
            case DiscreteIntervalsKind.number:
                _dataType = 'number';
                break;
            case DiscreteIntervalsKind.date:
                _dataType = 'date';
                break;
            case DiscreteIntervalsKind.datetime:
                _dataType = 'datetime';
                break;
            case DiscreteIntervalsKind.time:
                _dataType = 'time';
                break;
            //LL: 26.04.23 BL
            case DiscreteIntervalsKind.boolean:
                _dataType = 'boolean';
                break;
        }
        return _dataType;
    }

    static evaluateDiscreteMapping(value, mapObject, dataType?): any {
        //LL: 14.11.19:
        if (value == null) {
            if (mapObject.discreteIntervals != null && mapObject.discreteIntervals.nullMappedValue != null) {
                return mapObject.discreteIntervals.nullMappedValue;
            }
        }

        //LL: 28.10.21: see below
        if (mapObject.dataType === 'boolean') {
        }

        const less = (type, v1, v2) => {
            if (type === 'string') {
                return v1.toString().localeCompare(v2.toString()) < 0;
            } else {
                return v1 < v2;
            }
        };

        //LL: 29.10.20: "trim" bug:  this type of "labels":
        let mappedDataType = MappingUtilities.evaluateDiscreteMappingDataType(mapObject);

        //LL: Oleg's swift code only for numbers and strings:
        let result: any;
        if (
            (_.isNumber(value) || _.isString(value)) &&
            mapObject &&
            (mapObject.dataType === 'number' || mapObject.dataType === 'string')
        ) {
            const di = mapObject.discreteIntervals;

            //LL: labels.length = values.length + 1

            //if (!less(mapObject.dataType, value, di.values[di.values.length - 1])
            //    && (di.labels[di.values.length - 1] == null ||
            //       (mappedDataType === 'string' && di.labels[di.values.length - 1].trim() === "") ||
            //       (mappedDataType !== 'string' && di.labels[di.values.length - 1] === "")) ) {
            //    result = getIntervalPlaceholderValue(di.values[di.values.length - 1], Infinity, 'string', true);
            //}
            if (!less(mapObject.dataType, value, di.values[di.values.length - 1])) {
                if (
                    di.labels[di.values.length] == null ||
                    (mappedDataType === 'string' && di.labels[di.values.length].trim() === '') ||
                    (mappedDataType !== 'string' && di.labels[di.values.length] === '')
                ) {
                    di.labels[di.values.length] = getIntervalPlaceholderValue(
                        di.values[di.values.length - 1],
                        Infinity,
                        'string',
                        true
                    );
                }
                result = di.labels[di.values.length];
            } else {
                for (var i = 0; i < di.values.length; i++) {
                    if (less(mapObject.dataType, value, di.values[i])) {
                        if (
                            di.labels[i] == null ||
                            (mappedDataType === 'string' && di.labels[i].trim() === '') ||
                            (mappedDataType !== 'string' && di.labels[i] === '')
                        ) {
                            //let left = (i === 0 ? null : di.values[i - 1]);
                            let left = i === 0 ? -Infinity : di.values[i - 1];
                            let right = i < di.values.length ? di.values[i] : Infinity;

                            di.labels[i] = getIntervalPlaceholderValue(left, right, 'string', true);
                        }

                        result = di.labels[i];

                        break;
                    }
                }
            }

            if (result == null) {
                result = di.labels[di.labels.length - 1];
            }
        }

        //LL: 18.11.19: not to spoil Oleg's code:
        //LL:  see ColorHexWrapper.evaluateColor for discrete
        else {
            if (mapObject == null) {
                return null;
            }

            // check value type,
            let wrongDataType = false;
            let dataTypeInObj = mapObject.dataType != null ? mapObject.dataType : 'i';
            if (dataTypeInObj != null && dataType != null) {
                switch (dataType) {
                    case 'i':
                    case 'r':
                        wrongDataType = !(dataTypeInObj === 'i' || dataTypeInObj === 'r' || dataTypeInObj === 'number');
                        break;
                    case 'time':
                        wrongDataType = dataTypeInObj !== 'time';
                        break;
                    case 'date':
                    case 'datetime':
                        wrongDataType = !(dataTypeInObj === 'date' || dataTypeInObj === 'datetime');
                        break;
                    case 'b': // no in ColorMapping ? LL: 28.10.21: now used
                        wrongDataType = !(dataTypeInObj === 'b' || dataTypeInObj === 'boolean');
                        break;
                    case 's':
                        wrongDataType = !(dataTypeInObj === 's' || dataTypeInObj === 'string');
                        break;
                    default:
                        // 'e'
                        wrongDataType = true;
                }
            }
            if (wrongDataType) {
                console.log(
                    'evaluateDiscreteMapping: wrong data types, dataType = ' +
                        dataType +
                        ' dataTypeInObj = ' +
                        dataTypeInObj
                );
                //LL:   Message  or  return ERROR ???
                return null;
            }

            let discreteIntervals = mapObject.discreteIntervals;

            //LL: 28.10.21:
            if (mapObject.dataType === 'boolean') {
                if (value === true) {
                    if (discreteIntervals != null && discreteIntervals.trueMappedValue != null) {
                        return discreteIntervals.trueMappedValue;
                    }
                }
                if (value === false) {
                    if (discreteIntervals != null && discreteIntervals.falseMappedValue != null) {
                        return discreteIntervals.falseMappedValue;
                    }
                }
            }

            if (
                discreteIntervals == null ||
                discreteIntervals.labels == null ||
                discreteIntervals.labels.length === 0
            ) {
                return null;
            }

            //  if dataTypeInObj is date/datetime, values are date-strings ("2012-01-27"),
            //  but "value" can be date (when called in Grid, for example) or string
            //LL: use here "dataTypeInObj", not "dataType", because the last can be null
            let valueString = value;
            if (DateTimeFunctions.isTypeOfDateOrDatetime(dataTypeInObj)) {
                if (typeof value !== 'string') {
                    valueString = Globalize.formatDate(value, {
                        raw: DateTimeFunctions.TimeValueFormat
                    }); // 'yyyy-MM-ddTHH:mm:ss'
                }
            }

            //  if dataTypeInObj is time, values are time-date-strings ("1899-12-31T16:03:00"),
            //                it is DateTimeFunctions.TimeValueFormat = 'yyyy-MM-ddTHH:mm:ss'
            //  but "value" is "03:30:00"
            let values = discreteIntervals.values;
            if (DateTimeFunctions.isTypeOfTime(dataTypeInObj)) {
                values = _.map(values, (dateString: string) => {
                    dateString = DateTimeFunctions.convertTimeValueAsDateToString(dateString);
                    return dateString;
                });
            }

            //    { labels:[], values:[] }   labels are of resulting type   labels.len = values.len + 1
            for (var i = 0; i < values.length; i++) {
                if (DateTimeFunctions.isTypeOfTime(dataTypeInObj)) {
                    if (
                        DateTimeFunctions.convertTimeStringToDate(valueString).valueOf() <
                        DateTimeFunctions.convertTimeStringToDate(values[i]).valueOf()
                    ) {
                        result = discreteIntervals.labels[i];
                        break;
                    }
                } else {
                    if (new Date(valueString).valueOf() < new Date(values[i]).valueOf()) {
                        result = discreteIntervals.labels[i];
                        break;
                    }
                }
            }

            let idx = discreteIntervals.labels.length - 1;

            //if (discreteIntervals.labels[idx] == null || discreteIntervals.labels[idx].trim() === '') {
            //LL: 23.05.23 BL trim err
            if (
                discreteIntervals.labels[idx] == null ||
                (mappedDataType === 'string' && discreteIntervals.labels[idx].trim() === '') ||
                (mappedDataType !== 'string' && discreteIntervals.labels[idx] === '')
            ) {
                let left = idx === 0 ? null : discreteIntervals.values[idx - 1];
                let right = idx < discreteIntervals.values.length ? discreteIntervals.values[idx] : Infinity;

                discreteIntervals.labels[idx] = getIntervalPlaceholderValue(left, right, 'string', false);
            }

            if (result == null) {
                result = discreteIntervals.labels[discreteIntervals.labels.length - 1];
            }
        }

        return result;
    }

    static getMappingSchema(themeMappingSet, mappingName) {
        return _.findWhere(themeMappingSet, { name: mappingName });
    }

    static getIntervalPlaceholderValue(left, right, type, inHTML) {
        // left can be null, -Infinity,  right can be Infinity
        let rightStr: any = right;
        if (type === 'time') {
            rightStr =
                rightStr !== Infinity ? DateTimeFunctions.convertTimeValueAsDateToString(rightStr) : timeInfinity;
        } else {
            rightStr = rightStr.toString();
        }

        //  '\u2264' <=   '\u2265'  UTF-16(hex) 0x2265  UTF-8 e289a5 &ge; ≥ >=     \u003e >
        //   https://mathiasbynens.be/notes/javascript-escapes
        //      UTF-8 (hex)	0xE2 0x89 0xA5 (e289a5)   '\u{1d306}' '\u{e289a5}'
        //     (The unicode for ≥ is "U+ 2265".)

        // https://stackoverflow.com/questions/12140003/ascii-code-for-less-than-or-equal-to
        //   The character ≤ isn't in the ASCII table. However, there are several ways to embed it in HTML.
        //   Firstly, using HTML entities: either &le;, &#8804;, or &#x2264.
        //     Just place this code in your HTML where you want the ≤ symbol to be.
        //   Alternatively, ensure that your html file is utf8 encoded, and include
        //    the meta tag <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" /> in the <head> of your document.
        //    You can then copy and paste the ≤ character directly into your document.

        //  He:  !!!
        //  I always just underline < and > which are standard keyboard characters.
        //  It may be a little clugey, but it works, and it saves remembering numbers.

        //LL:  won't work, Labels are returned by backend as values !!!  Suppose, they are converted (truncated ?) to ASCII ?

        //   https://pixelplus.ru/samostoyatelno/stati/vnutrennie-faktory/tablica-simvolov-unicode.html
        //   https://unicode-table.com/ru/
        let leftStr: any = left;
        if (leftStr == null || leftStr === -Infinity) {
            leftStr = '\u003C'; // "<";
        } else {
            if (type === 'time') {
                leftStr = DateTimeFunctions.convertTimeValueAsDateToString(leftStr);
            } else {
                leftStr = leftStr.toString();
            }
            if (right === Infinity) {
                //leftStr = '\u2265' + leftStr;  //  >=
                leftStr = (inHTML ? '\u2265' : '>=') + leftStr; //  >=   OK
                //leftStr = (inHTML ? '\u2265' : '≥')  + leftStr;  //  >=  NO just =

                //leftStr = (inHTML ? '\uD834\uDF06' : '\uD834\uDF06')  + leftStr;
                rightStr = '';
            } else {
                //leftStr = leftStr + '-';
                //LL: 15.05.19: case when only one value, not interval:
                if (type === 'i' && right - left <= 1) {
                    //LL: here right != Infinity & left != -Infinity
                    rightStr = '';
                } else {
                    leftStr = leftStr + '-';
                }
            }
        }

        let placeholderValue = leftStr + rightStr;

        return placeholderValue;
    }
}
